import React from 'react';
import { Widget } from '@typeform/embed-react';
import '../css/contact.css';

export default function ContactForm(props) {
	return (
		<Widget id={props.formID} className='contactForm' />
	);
}